<template>
  <header class="sla-header">
    <div class="sla-header__l">
      <a v-bind:href="context.home_url">Johannes Siipola</a>
    </div>
    <div class="sla-header__r">

      <div class="sla-menu">
        <BBCMenu v-bind:items="items">
          <template v-slot:button="slotProps">
            <div>
              <button ref="mybutton" v-on:click="modalOpen = true" class="sla-header-button">☰</button>

              <MountingPortal mountTo="body" name="source" append>
                <transition name="side">
                  <div class="menu-sidebar__inner" v-if="modalOpen">
                    <a class="sidebar-button"
                       v-bind:href="hiddenItem.url"
                       v-for="hiddenItem in slotProps.hiddenItems"
                       v-bind:class="hiddenItem.classes"
                       v-bind:target="hiddenItem.target"
                    >
                      <span>{{ hiddenItem.title }}</span>
                    </a>
                  </div>
                </transition>

                <transition name="fade">
                  <div class="menu-shade"
                       v-if="modalOpen"
                       v-on:click.self="modalOpen = false"
                  ></div>
                </transition>
              </MountingPortal>

            </div>
          </template>
          <template v-slot:visibleItems="slotProps">

            <ul style="display: flex">

            <li v-for="item in slotProps.visibleItems" style="white-space: nowrap">
              <a
                v-bind:href="item.url"
                v-bind:class="item.classes"
                v-bind:target="item.target"
            >
                {{ item.title }}
              </a>
            </li>

            </ul>
          </template>
        </BBCMenu>
        <!--<a v-for='(item, index) in items'
           v-bind:class="item.classes"
           v-bind:target="item.target"
           :key='index'
           :href='item.url'>
          {{ item.title }}
        </a>-->
      </div>

    </div>
  </header>
</template>

<script>

import PriorityPlus from 'vue-priority-plus-navigation';
import BBCMenu from './BBCMenu.vue';
import {MountingPortal} from "portal-vue";

export default {
  components: {
    PriorityPlus,
    BBCMenu,
    MountingPortal,
  },
  props: ['context'],
  data: function () {
    return {
      modalOpen: false,
      items: this.context.menu_items,
    }
  }
}
</script>